export const API_VERSION = "ffaba47493a3";
